import { TasksTableSort } from '../../types';

export const tableSortDefaults: TasksTableSort = {
	direction: 'desc',
	orderBy: 'startDate',
}
